const admin_pt = require('./admin.json')
export default admin_pt